import { workAreaOptionsResponseSchema } from '@houzy/schemas/partner-cockpit/onboarding';
import { queryOptions, useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query';

import { apiRequest, retryQueryUnlessClientError } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';
import { STALE_TIME_MS } from '../../../lib/queryClient';
import type { Canton } from '../types';

export async function fetchCantons(signal?: AbortSignal): Promise<Canton[]> {
    const response = await apiRequest(partnerCockpitApiPath('onboarding/work-area/options'), {
        signal,
        responseSchema: workAreaOptionsResponseSchema,
    });
    return response.cantons;
}

export const cantonsQueryOptions = queryOptions({
    queryKey: ['onboarding', 'cantons'],
    queryFn: ({ signal }) => fetchCantons(signal),
    staleTime: STALE_TIME_MS,
    retry: retryQueryUnlessClientError,
});

export function useCantons(): UseSuspenseQueryResult<Canton[]> {
    return useSuspenseQuery(cantonsQueryOptions);
}
